import { useMutation } from 'react-query'

import { APIError } from '../../../utils'
import { updateVatDeclarationSettlement } from '../query-api'

interface UseUpdateVatDeclarationSettlementProps {
  onError?: (error?: APIError) => void
  onSuccess?: () => void
}

export interface UpdateVatDeclarationSettlementProps {
  customVatPayoutAmount?: number
  id: string
  isSettled: boolean
}

export const useUpdateVatDeclarationSettlement = (props?: UseUpdateVatDeclarationSettlementProps) => {
  const { onError, onSuccess } = props || {}

  const { mutate: update, isLoading: isProcessing } = useMutation(
    ({ id, isSettled, customVatPayoutAmount }: UpdateVatDeclarationSettlementProps) =>
      updateVatDeclarationSettlement({ id, isSettled, customVatPayoutAmount }),
    {
      onError,
      onSuccess,
    },
  )

  return { update, isProcessing }
}
